import classNames from 'classnames/bind';
import { TFunction } from 'next-i18next';
import { PostBody } from 'types/post';

import React from 'react';

import AttachmentDisplayer from 'components/AttachmentDisplayer';
import Content from 'components/new/Posts/ReadOnlyContent/Content';

import { Attachment } from 'schema/Post/types';

import styles from '../Post.module.scss';

const cx = classNames.bind(styles);

interface ExpandableContentProps {
  body: PostBody;
  hasAttachment: boolean;
  attachments?: Attachment[];
  t: TFunction;
  isComment?: boolean;
  id: string;
}

const ExpandableContent = ({
  body,
  hasAttachment,
  attachments,
  t,
  isComment,
  id,
}: ExpandableContentProps) => {
  return (
    <article
      className={cx('post__content', hasAttachment ? 'post__content--attachment' : '')}
      data-qa="post__content"
    >
      <Content body={body} id={id} />
      {hasAttachment && (
        <AttachmentDisplayer attachments={attachments || []} isComment={isComment} t={t} />
      )}
    </article>
  );
};

export default ExpandableContent;
